export const INPUT_PATTERNS_CONSTANT = {
  NUMBER: /^\d+$/,
  NUMBER_RANGE: /^\d{6,10}$/,
};
